<div class="abundance-page">
  <section class="abundance-hero">
    <div class="hero-pattern hero-pattern-left"></div>
    <div class="hero-pattern hero-pattern-right"></div>

    <div class="hero-inner">
      <div class="hero-ribbon">
        <span>ABUNDANCE</span>
        <img src="../../assets/images/abundance/logo.svg" alt="丰芒标识" class="hero-ribbon-logo">
      </div>

      <div class="hero-copy">
        <p class="hero-kicker">丰芒</p>
        <h1>丰芒-专业智能排料专家</h1>
        <p class="hero-desc">
          让文件整理、自动排料与输出流程形成更清晰的生产闭环，适合需要高频排版与高材料利用率的业务场景。
        </p>
        <button class="hero-button" type="button" (click)="openTrialPage()">开始试用</button>
      </div>

      <div class="hero-scroll-mark"></div>
    </div>

    <div class="hero-cut hero-cut-bottom hero-cut-left"></div>
    <div class="hero-cut hero-cut-bottom hero-cut-left-center"></div>
    <div class="hero-cut hero-cut-bottom hero-cut-right-center"></div>
    <div class="hero-cut hero-cut-bottom hero-cut-right"></div>
   
  </section>

  <section class="section section-light overview-section">
    <div class="section-header">
      <p class="section-kicker">丰芒</p>
      <h2>什么是丰芒？</h2>
      <p>
        面向板材排料、文件整理与自动版面优化场景设计，
        丰芒以更直接的流程帮助团队提升生产效率、节省材料并稳定输出。
      </p>
    </div>

    <div class="overview-grid">
      <article class="overview-card" *ngFor="let item of overviewItems">
        <img [src]="item.icon" [alt]="item.title" class="center">
        <h3>{{ item.title }}</h3>
        <p>{{ item.description }}</p>
      </article>
    </div>

    <div class="cover-frame">
      <img src="../../assets/images/abundance/software_cover.png" alt="丰芒软件主界面">
    </div>
  </section>

  <section class="section section-dark operation-section">
    <div class="hero-cut hero-cut-top hero-cut-left"></div>
    <div class="hero-cut hero-cut-top hero-cut-left-center"></div>
    <div class="hero-cut hero-cut-top hero-cut-left-middle"></div>
    <div class="hero-cut hero-cut-top hero-cut-right-middle"></div>
    <div class="hero-cut hero-cut-top hero-cut-right-center"></div>
    <div class="hero-cut hero-cut-top hero-cut-right"></div>
    <div class="hero-cut hero-cut-bottom hero-cut-left"></div>
    <div class="hero-cut hero-cut-bottom hero-cut-left-center"></div>
    <div class="hero-cut hero-cut-bottom hero-cut-right-center"></div>
    <div class="hero-cut hero-cut-bottom hero-cut-right"></div>
  
    <div class="section-header light">
      <p class="section-kicker">流程</p>
      <h2>很容易操作</h2>
      <p>只需几步，即可完成从导入文件到自动排料输出的核心操作流程。</p>
    </div>

    <div class="operation-layout">
      <div class="operation-steps">
        <article class="operation-step" *ngFor="let step of operationSteps">
          <div class="step-index">{{ step.index }}</div>
          <div class="step-copy">
            <h3>{{ step.title }}</h3>
            <p>{{ step.description }}</p>
          </div>
        </article>
      </div>

      <div class="operation-shots">
        <div class="shot-card">
          <img src="../../assets/images/abundance/software_part_1.png" alt="丰芒操作界面局部一">
        </div>
        <div class="shot-card">
          <img src="../../assets/images/abundance/software_part_2.png.png" alt="丰芒操作界面局部二">
        </div>
      </div>
    </div>
  </section>

  <section class="section section-light reason-section">
    <div class="section-header">
      <p class="section-kicker">理由</p>
      <h2>为什么选择丰芒？</h2>
      <p>更适合排料型业务的操作节奏，让效率、材料利用率与稳定输出同时得到改善。</p>
    </div>

    <div class="reason-layout">
      <article class="reason-main-card">
        <div class="reason-main-image">
          <img src="../../assets/images/abundance/Save material costs.png" alt="节省材料成本示意图">
        </div>
        <div class="reason-main-copy">
          <h3>节省材料成本</h3>
          <p>优化排料结果，尽可能减少边角浪费，让每次生产都更接近可控与高效。</p>
          <button type="button" (click)="openContactPage()">立即咨询</button>
        </div>
      </article>

      <div class="reason-side-list">
        <article class="reason-side-card" *ngFor="let item of reasonCards">
          <img [src]="item.icon" [alt]="item.title">
          <div>
            <h3>{{ item.title }}</h3>
            <p>{{ item.description }}</p>
          </div>
        </article>
      </div>
    </div>
  </section>

  <section class="section section-dark industries-section">
    <div class="hero-cut hero-cut-top hero-cut-left"></div>
    <div class="hero-cut hero-cut-top hero-cut-left-center"></div>
    <div class="hero-cut hero-cut-top hero-cut-left-middle"></div>
    <div class="hero-cut hero-cut-top hero-cut-right-middle"></div>
    <div class="hero-cut hero-cut-top hero-cut-right-center"></div>
    <div class="hero-cut hero-cut-top hero-cut-right"></div>
    <div class="hero-cut hero-cut-bottom hero-cut-left"></div>
    <div class="hero-cut hero-cut-bottom hero-cut-left-center"></div>
    <div class="hero-cut hero-cut-bottom hero-cut-right-center"></div>
    <div class="hero-cut hero-cut-bottom hero-cut-right"></div>
    <div class="industries-watermark">ABUNDANCE</div>
    <div class="industries-header">
      <!-- <p class="section-kicker">行业应用</p> -->
      <h2>行业与应用</h2>
      <p>适用于对材料排布、版面组合与批量输出效率有明确要求的生产型行业。</p>
    </div>

    <div class="industries-grid">
      <article class="industry-card" *ngFor="let item of industryItems">
        <div class="industry-image">
          <img [src]="item.image" [alt]="item.title">
        </div>
        <p>{{ item.title }}</p>
      </article>
    </div>
  </section>

  <section class="section section-light advantage-section">
    <div class="section-header">
      <p class="section-kicker">优势</p>
      <h2>助力每一位用户将业务<br>提升到新的高度</h2>
      <p>从自动排料到稳定输出，丰芒帮助团队把关键流程建立得更高效，也更适合长期生产使用。</p>
    </div>

    <div class="advantage-grid">
      <article class="advantage-card" *ngFor="let item of advantageItems; let i = index"
        (mouseenter)="onMouseEnter(i, $event)"
        (mouseleave)="onMouseLeave(i)"
        (mousemove)="onMouseMove($event, i)">
        <div class="light-ball" *ngIf="item.isHovered"
          [ngStyle]="{'transform': 'translate3d(' + item.position.x + 'px, ' + item.position.y + 'px, 0)'}">
        </div>
        <img [src]="item.icon" [alt]="item.title">
        <h3>{{ item.title }}</h3>
        <p>{{ item.description }}</p>
      </article>
    </div>
  </section>

  <section style="height: 12px;width: 100%;position: relative;">
    <div class="hero-cut-bottom-black"></div>
    <div class="hero-cut hero-cut-top hero-cut-left"></div>
    <div class="hero-cut hero-cut-top hero-cut-left-center"></div>
    <div class="hero-cut hero-cut-top hero-cut-left-middle"></div>
    <div class="hero-cut hero-cut-top hero-cut-right-middle"></div>
    <div class="hero-cut hero-cut-top hero-cut-right-center"></div>
    <div class="hero-cut hero-cut-top hero-cut-right"></div>
  </section>
</div>
